/* eslint-disable */
export default {
  forward: 'Doorverbinden',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
